import { Navigate } from 'react-router-dom';

import { useProfile } from 'context/profile';
import useDefaultRedirect from 'hooks/useDefaultRedirect';
import { Accessor } from 'models/Profile';

type Route = {
  permission: Accessor;
  path: string;
};

type PermissionRedirectProps = {
  routes: Route[];
};

export default function PermissionRedirect({ routes }: PermissionRedirectProps) {
  const { profile } = useProfile();
  const fallback = useDefaultRedirect();

  const match = routes.find((r) => profile.has(r.permission));

  return <Navigate to={match?.path ?? fallback} replace />;
}
